import { push } from 'react-router-redux';
import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';
import { selectify } from '../../businessLogic/util';
import { download } from '../../businessLogic/export';
import { parseLocations } from '../../businessLogic/map';
import { setPoints } from './local/actions';
import json2csv from "json2csv";
import { Event } from "../../GAnalytics";
import JSZip from 'jszip';

let timeout;

// Wait 5 seconds then wipe message
const timeoutToWipeMessage = (dispatch) => {
	timeout = setTimeout(() => {
		dispatch(setDocumentStatus("IDLE"));
		dispatch(setDocumentMessage(""));
	}, 5000);
};

export function clearForm() {
	return {
		type: "CLEAR_FORM"
	};
}

export function selectDocument(document, index) {
	return {
		type: "SELECT_DOCUMENT",
		document,
		index
	};
}

function isSelectingDocument(id) {
	return {
		type: "IS_SELECTING_DOCUMENT",
		id
	};
}

function isFetchingDocuments(bool) {
	return {
		type: "IS_FETCHING_DOCUMENTS",
		bool
	};
}

export function isFetchingMap(bool) {
	return {
		type: "IS_FETCHING_MAP",
		bool
	};
}
function setDocumentId(id) {
	return {
		type: "SET_DOCUMENT_ID",
		id
	};
}

function setDocuments(documents) {
	return {
		type: "SET_DOCUMENTS",
		documents
	};
}

function setDocumentStatus(status) {
	return {
		type: "SET_DOCUMENT_STATUS",
		status
	};
}

function setDocumentMessage(message) {
	return {
		type: "SET_DOCUMENT_MESSAGE",
		message
	};
}

function setDocumentProgress(progress) {
	return {
		type: "SET_DOCUMENT_PROGRESS",
		progress
	};
}

function setLog(log) {
	return {
		type: "SET_LOG",
		log
	};
}

export function saveDocument(document, files, points, id) {
	return function(dispatch, getState) {
		const isEdit = id !== null;
		const URL = isEdit ? `${ROOT}/document/${id}/` : `${ROOT}/document/`;

		const data = new FormData();

		// Changes to something django accepts, then revert back.
		if (document.groups.length === 0) {
			document.groups[0] = {id: 2, name: "Repositório Dinâmico de Documentos"};
		}
		let proj = document.projects[0];
		let group = document.groups[0];
		document.projects[0] = document.projects[0].id;
		document.groups[0] = document.groups[0].id;

		data.append('document', JSON.stringify(document));

		document.projects[0] = proj;
		document.groups[0] = group;

		files.map((file) => data.append('files[]', file));

		// This creates two new keys in the FormData.
		// One is the img[] array, which is similar to the files[] array. It's plain files.
		// The other is the points[] array, which is a JSON of points with a new array (img) specifying
		// caption for the images and the filename of the images we should refer with the given point
		const newPoints = [];
		const tzlookup = require("tz-lookup");
		points.map((point) => {
			const filenames = [];
			point.img.map((file) => {
				data.append('img[]', file.src);
				let metadata = {
					filename: file.src.name,
					caption: file.caption ? file.caption : "",
					timezone: tzlookup(Number(point.lat), Number(point.lng))
				};
				if (file.datetime) metadata.datetime = file.datetime;
				filenames.push(metadata);
			});

			newPoints.push({
				id: point.id,
				lat: point.lat, lng: point.lng, img: filenames, 
				savedImg: point.savedImg, label: point.label
			});
		});

		data.append('points', JSON.stringify(newPoints));

		clearInterval(timeout);

		const xhr = new XMLHttpRequest();

		xhr.upload.onprogress = (e) => {
			if (e.lengthComputable) {
				const percentComplete = Math.round(100 * (e.loaded / e.total));
				dispatch(setDocumentProgress(percentComplete));
			} else console.warn("Size unknown!");
		};

		xhr.open(isEdit ? 'PUT' : "POST", URL, true);

		xhr.onreadystatechange = function () {
			if ( xhr.readyState === XMLHttpRequest.DONE ) {
				if ( xhr.status >= 200 && xhr.status < 300 ) {

					// Dispatch actions to visual feedback
					dispatch(setDocumentStatus('SUCCESS'));
					dispatch(setDocumentMessage("Salvo com sucesso!"));
					dispatch(setDocumentProgress(0));

					let innerId = id;

					// Parse response in case we are not editing
					if ( !isEdit ) {
						const id = parseInt(JSON.parse(JSON.parse(xhr.response)).documentId);
						innerId = id;
						dispatch(setDocumentId(id));
						dispatch(push(`/admin/documents/view/${id}`));
					}

					dispatch(getDocumentPoints(innerId));
					dispatch(getDocumentLog(innerId));

					// Start countdown to wipe feedback message
					timeoutToWipeMessage(dispatch);
					Event('Documents', 'save', 'Salvou o documento: ' + id);
				} else {
					// Something went wrong...
					dispatch(setDocumentStatus('ERROR'));
					const errorDetails = xhr.responseText.split('\n')[1];
					dispatch(setDocumentMessage(`${xhr.statusText} - ${errorDetails}`));
					dispatch(setDocumentProgress(0));
					timeoutToWipeMessage(dispatch);
					console.error(xhr.statusText);

					Event('Documents', 'save', `Falhou ao salvar o documento: ${id} Detalhes: ${errorDetails}`);
				}
			}
		};

		xhr.setRequestHeader("Authorization", 'Token ' + getState().login.credentials.token);

		dispatch(setDocumentStatus('IN_PROGRESS'));
		xhr.send(data);
	};
}

export function deleteDocument(id, index) {
	Event('Documents', 'delete', `deletou um documento: ${id}`);
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/`;
		return fetch(URL, {
			method: 'DELETE',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(push("/admin/documents/view/"));
		})
		.catch((e) => {
			alert(e);
		});
	};
}

export function getDocuments() {
	return function(dispatch, getState) {
		const URL = `${ROOT}/document/`;
		dispatch(isFetchingDocuments(true));
		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(isFetchingDocuments(false));
			dispatch(setDocuments(json));
		})
		.catch((e) => {
			dispatch(isFetchingDocuments(false));
			console.error(e);
		});
	};
}

export function viewDocument(id) {
	Event('Documents', 'view', `Visualizou o documento: ${id}`);
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/`;

		dispatch(isSelectingDocument(id));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			let authorsTidy = [];

			// se tiver erro eh no reverse
			json.docAuthors.forEach((authorNorder) => {
				if (authorNorder.author === null ) {
					authorsTidy = json.authors;
					return;
				}
				json.authors.forEach((elem) => {
					if (elem.id === authorNorder.author ) {
						authorsTidy.push({
							id: authorNorder.author,
							name: elem.name,
							authorOrderByDoc: authorNorder.authorOrderByDoc
						});
					}
				});
			});

			authorsTidy.sort((a, b) => {
				if (a.authorOrderByDoc > b.authorOrderByDoc) {
					return 1;
				}
				if (a.authorOrderByDoc < b.authorOrderByDoc) {
					return -1;
				}
				// a must be equal to b
				return 0;
			});
			const locations = parseLocations(json.shapes);
			const doc = {
				title: json.title,
				url: json.url,
				institutions: selectify(json.institutions),
				authors: selectify(authorsTidy),
				keywords: selectify(json.keywords),
				themes: selectify(json.themes),
				folder: json.folder === null ? json.folder : { value: json.folder.id, label: json.folder.name },
				hasOwner: json.hasOwner === 1,
				isPublic: json.isPublic === 1,
				groups: json.groups,
				sectors: locations.sectors,
				localities: locations.localities,
				samplingPoints: locations.samplingPoints,
				points: json.points,
				//points: locations.points,
				rects: locations.rects,
				datetime: json.datetime,
				startCoverageDate: json.startCoverageDate,
				endCoverageDate: json.endCoverageDate,
				description: json.description,
				files: json.files,
				log: json.log,
				projects: json.projects
			};
			dispatch(selectDocument(doc, parseInt(id)));
			dispatch(isSelectingDocument(null));
			dispatch(push(`/admin/documents/view/${id}`));
		})
		.catch((e) => {
			dispatch(isSelectingDocument(null));
			console.error(e);
		});
	};
}

export function toogleSaveButtonValue(nextVal) {
	return function(dispatch, getState) {
		dispatch(toogleBTSave(nextVal));
	};
}
export function toogleNextPageValue(nextVal) {
	return function(dispatch, getState) {
		dispatch(toogleNextPage(nextVal));
	};
}
function toogleNextPage(nextPage) {
	return {
		type: "ALLOW_NEXTPAGE",
		nextPage
	};
}

export function getDocumentLocations(id, onSuccess) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/shape/`;
		dispatch(isSelectingDocument(id));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			const locations = parseLocations(json);
			dispatch(isSelectingDocument(null));
			onSuccess(locations);
		})
		.catch((e) => {
			dispatch(isSelectingDocument(null));
			console.error(e);
		});
	};
}

export function getDocumentLog(id) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/`;

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setLog(json.log));
			window.scrollTo(0, document.body.scrollHeight);
		})
		.catch((e) => {
			console.error(e);
		});
	};
}

export function getDocumentFiles(id, onSuccess) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/file/`;

		dispatch(isSelectingDocument(id));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(isSelectingDocument(null));
			onSuccess(json);
		})
		.catch((e) => {
			dispatch(isSelectingDocument(null));
			console.error(e);
		});
	};
}

export function checkExistance(filehash) {
	return function(dispatch, getState) {
		const URL = `${ROOT}/file/check/${filehash}/`;

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			return json;
		})
		.catch((e) => {
			console.error(e);
		});
	};
}

export function getDocumentPoints(id) {
	return function(dispatch, getState) {
		const URL = `${ROOT}/document/${id}/points/`;
		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setPoints(json, false));
		})
		.catch((e) => {
			dispatch(isSelectingDocument(null));
			console.error(e);
		});
	};
}

export function getDocumentDetails(id, onSuccess) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/document/${id}/quickdetail/`;

		dispatch(isSelectingDocument(id));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(isSelectingDocument(null));
			let authorsTidy = [];

			// se tiver erro eh no reverse
			json.docAuthors.forEach((authorNorder) => {
				if (authorNorder.author === null ) {
					authorsTidy = json.authors;
					return;
				}
				json.authors.forEach((elem) => {
					if (elem.id === authorNorder.author ) {
						authorsTidy.push({
							id: authorNorder.author,
							name: elem.name,
							authorOrderByDoc: authorNorder.authorOrderByDoc
						});
					}
				});
			});

			authorsTidy.sort((a, b) => {
				if (a.authorOrderByDoc > b.authorOrderByDoc) {
					return 1;
				}
				if (a.authorOrderByDoc < b.authorOrderByDoc) {
					return -1;
				}
				// a must be equal to b
				return 0;
			});
			json.authors = authorsTidy;
			onSuccess(json);
		})
		.catch((e) => {
			//redirectIfUnauthorized(e, dispatch);
			dispatch(isSelectingDocument(null));
			console.error(e);
		});
	};
}

export function deleteFile(docId, filehash, onSuccess) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/file/remove/${docId}/${filehash}/`;

		clearInterval(timeout);

		// Set visual UI
		dispatch(setDocumentStatus('IN_PROGRESS'));

		return fetch(URL, {
			method: 'DELETE',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setDocumentStatus('SUCCESS'));
			dispatch(setDocumentMessage("Removido com sucesso!"));
			timeoutToWipeMessage(dispatch);
			onSuccess();
		})
		.catch((e) => {
			dispatch(setDocumentStatus('ERROR'));
			dispatch(setDocumentMessage(e.message));
			timeoutToWipeMessage(dispatch);
			console.error(e);
		});
	};
}

export function addFiles(id, files, onSuccess) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/file/`;

		const data = new FormData();
		data.append('document', id);
		files.map((file) => data.append('files[]', file));

		clearInterval(timeout);

		const xhr = new XMLHttpRequest();

		xhr.upload.onprogress = (e) => {
			if (e.lengthComputable) {
				const percentComplete = Math.round(100 * (e.loaded / e.total));
				dispatch(setDocumentProgress(percentComplete));
			} else console.warn("Size unknown!");
		};

		xhr.open('POST', URL, true);

		xhr.onreadystatechange = function () {
			if ( xhr.readyState === XMLHttpRequest.DONE ) {
				if ( xhr.status >= 200 && xhr.status < 300 ) {
					dispatch(setDocumentStatus('SUCCESS'));
					dispatch(setDocumentMessage("Salvo com sucesso!"));
					dispatch(setDocumentProgress(0));
					timeoutToWipeMessage(dispatch);
					onSuccess();
				} else {
					// Something went wrong...
					dispatch(setDocumentStatus('ERROR'));
					dispatch(setDocumentMessage(xhr.statusText));
					dispatch(setDocumentProgress(0));
					timeoutToWipeMessage(dispatch);
					console.error(xhr.statusText);
				}
			}
		};

		xhr.setRequestHeader("Authorization", 'Token ' + getState().login.credentials.token);

		dispatch(setDocumentStatus('IN_PROGRESS'));
		xhr.send(data);
	};
}

export function allowNextPage( nextPage ) {
	return function(dispatch, getState) {
		dispatch(allowNextPageT(nextPage));
	};
}
function allowNextPageT(nextPage) {
	return {
		type: "ALLOW_NEXTPAGE",
		nextPage
	};
}
export function toggleFavorite(id) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/group/toggle_favorite/${id}/`;
		dispatch(toggleFavoriteOpt(id));

		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			if ( JSON.parse(json) ) dispatch(getDocuments());
		})
		.catch((e) => {
			dispatch(toggleFavoriteOpt(id)); // Toggle again if we had any faild
			console.error(e);
		});
	};
}

function toggleFavoriteOpt(id) {
	return {
		type: "TOGGLE_FAVORITE",
		id
	};
}
function toogleBTSave(value) {
	return {
		type: "TOOGLE_SAVEBT",
		value
	};
}

export function downloadFile(file) {
	const filehash = file.hash;
	Event('Documents', 'downloadFile', `Baixou o arquivo: ${file.name}`);
	return function(dispatch, getState) {
		const form = document.createElement('form');
		form.method = "GET";
		form.action = `${ROOT}/file/download/${filehash}/`;
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	};
}

export function downloadFilesAsZip(docId) {
	Event('Documents', 'downloadFilesAsZip', `Baixou o zip com os arquivos: ${docId}`);
	return function(dispatch, getState) {
		dispatch(setIsProcessingZip());

		const URL = `${ROOT}/file/doc/${docId}/file_urls/`;
		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((files) => {
			var zip = new JSZip();

			function request(file) {
				return new Promise(function(resolve) {
					var httpRequest = new XMLHttpRequest();
					httpRequest.open("GET", `${file.url}`);
					httpRequest.responseType = 'blob';
					httpRequest.onload = function() {
						zip.file(file.name, this.response, { binary: true });
						resolve();
					};
					httpRequest.send();
				});
			}

			Promise.all(files.map(function(file) {
				return request(file);
			}))
			.then(function() {
				zip.generateAsync({
					type: "blob",
					compression: "STORE"
				})
				.then(function(content) {
					const a = document.createElement('a');
					document.body.appendChild(a);
					a.download = "Arquivos do documento " + docId;
					a.href = window.URL.createObjectURL(content);
					a.innerHTML = "download " + a.download;
					a.click();
					document.body.removeChild(a);
					dispatch(setIsProcessingZip(false));
				});
			});
		})
		.catch((e) => {
			dispatch(setIsProcessingZip(false));

			console.error(e);
		});
	};
}

/* CONSIDER CHANGING TO ANOTHER FILE */
export function setIsPublic(bool) {
	return {
		type: "SET_IS_PUBLIC",
		bool
	};
}

export function setHasOwner(bool) {
	return {
		type: "SET_HAS_OWNER",
		bool
	};
}

export function setItemsPerPage(itemsPerPage) {
	return {
		type: "SET_DOCUMENTS_ITEMS_PER_PAGE",
		itemsPerPage
	};
}

export function setCurrentPage(currentPage) {
	return {
		type: "SET_DOCUMENTS_CURRENT_PAGE",
		currentPage
	};
}

export function setIsProcessingZip(bool = true) {
	return {
		type: "SET_IS_PROCESSING_ZIP",
		bool
	};
}

export function exportList(list) {
	Event('Documents', 'exportList', 'Exportou os documentos para CSV');
	return function(dispatch, getState) {
		const state = getState();
		const fields = ['Título', 'Grupo', 'Pasta', 'Palavras-Chave', 'Setores', 'Localidades', 'Favorito'];
		const data = [];

		const generateKeywords = (l) => {
			const arr = [];
			l.keywords.map((k) => arr.push(state.domains.keywords.list.find((e) => e.id === k).name));
			return arr.join(",");
		};

		const generateSectors = (l, type) => {
			const arr = [];
			l.shapes.map((s) => {
				const f = state.domains.shapes.list.filter((e) => e.shapeType === type).find((e) => e.id === s);
				if ( typeof f !== "undefined" ) arr.push(f.name);
			});
			return arr.join(",");
		};

		list.map((l) => data.push(
			{
				"Título": l.title,
				"Grupo": l.isPublic && !l.hasOwner
					? "Público"
					: state.domains.groups.list.find((g) => g.id === l.groups[0]).name,
				"Pasta": l.folder === null ? "" : state.domains.folders.list.find((f) => f.id === l.folder).name,
				"Palavras-Chave": generateKeywords(l),
				"Setores": generateSectors(l, 5),
				"Localidades": generateSectors(l, 4),
				"Favorito": l.isFavorite ? "Sim" : "Não"
			}
		));
		const csv = json2csv({ data: data, fields: fields, del: ";" });
		download(csv);
	};
}


// WEBPACK FOOTER //
// ./src/state/documents/actions.js